<template>
  <div class="custom-select-box" :tabindex="tabindex" @focusout="handleFocusOut">
    <div class="selected" :class="{ open: open, error: error }" @click="open = !open">
      <span v-if="selectedOptions.length">{{ Number(selectedOptions.length) }} steps selected</span>
      <span v-else>Select steps</span>
    </div>
    <div class="items" :class="{ selectHide: !open }">
      <div class="item" v-for="option of questions" :key="`loop-through-${option.id}`">
        <label>
          <input :id="option.id" :value="option.id" type="checkbox" v-model="selectedOptions" @change="$emit('input', selectedOptions)" />
          <span class="my-auto"></span>
          <div class="ml-8">
            <div class="type">
              <span v-if="option.type !== 'SurveyCompletion'"
                >Step {{ option.stepSequence }} -
                {{ questionTypes[option.type] }}
                <b-badge v-if="option.isSkippable" variant="secondary">Optional</b-badge>
              </span>
              <span v-else-if="option.subtype === 'custom'">Custom Completion</span>
              <span v-else>End Activity</span>
            </div>
            <div class="title" :title="option.body">
              <span v-if="option.type == 'SurveyCompletion'">Skips to the end of the activity</span>
              <span v-else>{{ option.body }}</span>
            </div>
          </div>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  name: "loopThroughDropDown",
  props: {
    options: {
      type: Array,
      required: true
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0
    },
    selectedLoopThroughIds: {
      type: Array
    },
    questionTypes: {
      type: Object,
      required: true
    },
    error: {
      type: Boolean,
      default: false
    },
    filterSteps: {
      type: Array,
      required: true
    }
  },
  watch: {
    selectedLoopThroughIds: {
      handler(selectedStepIds) {
        if (!selectedStepIds) {
          this.selectedOptions = [];
          return;
        }

        this.selectedOptions = selectedStepIds;
      },
      deep: true
    },
    options: {
      handler(questions) {
        this.questions = this.filterQuestions(questions);
      },
      deep: true
    },
    filterSteps() {
      this.questions = this.filterQuestions(this.options);
    },
    questions: {
      deep: true,
      handler() {}
    }
  },
  data() {
    return {
      selectedOptions: this.selectedLoopThroughIds ? this.selectedLoopThroughIds : [],
      open: false,
      questions: []
    };
  },
  methods: {
    handleFocusOut(event) {
      if (!event.currentTarget.contains(event.relatedTarget)) {
        this.open = false;
      }
    },
    filterQuestions(questions) {
      const that = this;
      return _.filter(questions, function(o) {
        return (!o.branchingConfigured || o.branchingConfigured == undefined) && !that.filterSteps.includes(o.id);
      });
    }
  },
  mounted() {
    this.questions = this.filterQuestions(this.options);
    this.$emit("input", this.selectedOptions);
  }
};
</script>

<style lang="scss" scoped>
.custom-select-box {
  position: relative;
  width: 100%;
  text-align: left;
  outline: none;
  font-size: 12px;
  font-weight: normal;

  .selected {
    background-color: #ffffff;
    border-radius: 4px;
    border: solid 1px #d3dfe4;
    color: #4a4a4a;
    padding: 7px;
    padding-left: 11px;
    cursor: pointer;
    user-select: none;
    text-transform: capitalize;

    &:after {
      position: absolute;
      content: "";
      top: 13px;
      right: 10px;
      width: 0;
      height: 0;
      border: 6px solid transparent;
      border-color: #b0bac9 transparent transparent transparent;
    }

    .badge {
      padding: 4px;
      border-radius: 2px;
      background-color: #eee;
      font-family: Roboto-Regular;
      font-size: 9px;
      margin-left: 8px;
      color: #4a4a4a;
    }

    &.error {
      border-color: #f16559;
    }
  }

  .items {
    color: #4a4a4a;
    border-radius: 4px;
    overflow: hidden;
    position: absolute;
    background-color: #ffffff;
    left: 11px;
    right: 1px;
    top: 9px;
    box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.25);
    z-index: 1;
    min-width: 316px;
    max-height: 223px;
    overflow-y: auto;
    padding: 16px;

    scrollbar-width: thin;
    /* "auto" or "thin"  */
    scrollbar-color: #e6e9ed transparent;

    /* scroll thumb & track */
    &::-webkit-scrollbar {
      width: 7px;
      /* width of the entire scrollbar */
    }

    &::-webkit-scrollbar-track {
      background: transparent;
      /* color of the tracking area */
    }

    &::-webkit-scrollbar-thumb {
      background-color: #c5d1d6;
      /* color of the scroll thumb */
      border-radius: 20px;
      /* roundness of the scroll thumb */
      border: 3px solid transparent;
      /* creates padding around scroll thumb */
    }

    .item {
      color: #666669;
      //padding-left: 16px;
      cursor: pointer;
      user-select: none;
      margin-bottom: 4px;

      &:hover {
        background-color: #f8f9fa;
      }

      &:last-of-type {
        margin-bottom: 0;
      }

      .type {
        font-family: Roboto-Bold;
        font-size: 14px;
        color: #4a4a4a;
        text-transform: capitalize;
        margin-bottom: -2px;

        .badge {
          padding: 4px;
          border-radius: 2px;
          background-color: #eee;
          font-family: Roboto-Medium;
          font-size: 9px;
          margin-left: 8px;
          color: #4a4a4a;
        }
      }

      .title {
        font-size: 12px;
        color: #666669;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      /*checkbox data*/

      label {
        width: 100%;
        cursor: pointer;
        display: flex;

        span {
          vertical-align: middle;
          margin-right: 5px;
        }
      }

      input[type="checkbox"] {
        display: none;
        height: 16px;
        width: 16px;
      }

      input[type="checkbox"] + span:before {
        content: "";
        border: 0.1em solid #959fa4;
        border-radius: 4px;
        width: 16px;
        height: 16px;
        padding: 4px;
        color: transparent;
        background-color: #fff;
        background-repeat: no-repeat;
        background-position: center center;
        display: inline-block;
        margin-top: 2px;
      }

      input[type="checkbox"]:checked + span:before {
        background-color: #4c8ce4;
        border: 0.1em solid #4c8ce4;
        color: #fff;
        background-image: url(/static/img/checked-checkbox.svg);
      }
    }
  }
}

.selectHide {
  display: none;
}
</style>
